import React, { useState } from 'react'
import { usePopper } from 'react-popper'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'
import { paragraph1CommonStyles } from '../Typo'
import CloseIcon from '../../assets/icons/close-icon-grey.svg'

const Tooltip = ({ children, content, className }) => {
  const [referenceElement, setReferenceElement] = useState(null)
  const [popperElement, setPopperElement] = useState(null)
  const [arrowElement, setArrowElement] = useState(null)
  const [showTooltip, setShowTooltip] = useState(false)
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    modifiers: [
      {
        name: 'arrow',
        options: {
          element: arrowElement
        }
      },
      {
        name: 'offset',
        options: {
          offset: [-70, 16]
        }
      },
      {
        name: 'preventOverflow',
        options: {
          padding: 8
        }
      }
    ],
    placement: 'top-start'
  })

  const placement = attributes && attributes.popper && attributes.popper['data-popper-placement']

  const show = () => setShowTooltip(true)
  const hide = () => setShowTooltip(false)

  // TODO: need to remove Trigger element by using React.cloneElement but currently causing ref issue
  //   const tooltipTrigger = React.cloneElement(children, {
  //     ref: setReferenceElement,
  //     onFocus: show,
  //     onMouseEnter: show,
  //     onMouseLeave: hide,
  //     onBlur: hide
  //   })

  return (
    <>
      <Trigger
        ref={setReferenceElement}
        onFocus={show}
        onMouseEnter={show}
        onMouseLeave={hide}
        onBlur={hide}
        onClick={show}
      >
        {children}
      </Trigger>

      {showTooltip && (
        <TooltipStyled className={className} ref={setPopperElement} style={styles.popper} {...attributes.popper}>
          {content}
          <StyledCloseIconWrapper onFocus={hide}>
             <StyledIcon /> 
          </StyledCloseIconWrapper>
          <ArrowStyled ref={setArrowElement} style={styles.arrow} data-placement={placement} />
        </TooltipStyled>
      )}
    </>
  )
}

const Trigger = styled.span`
  display: inline-flex;
  position: relative;
`

const TooltipStyled = styled.div`
  ${paragraph1CommonStyles};
  font-weight: normal;
  color: ${({ theme }) => theme.palette.grey2};
  background: ${({ theme }) => theme.palette.white};
  min-width: 328px;
  padding: 16px;
  border: 2px solid ${({ theme }) => theme.palette.grey1};
  border-radius: 20px;
  box-shadow: 0px 4px 32px ${({ theme }) => theme.colors.boxShadowColor};
  z-index: 999;
  ${up('md')} {
    max-width: 400px;
    max-height: 160px;
    padding: 20px;
  }
`

const StyledCloseIconWrapper = styled.div`
  position: absolute;
  top: 1px;
  right: 10px;
  min-height: 12px;
  ${up('md')} {
    display: none;
  }
`
const StyledIcon = styled(CloseIcon)`
  height: 20px;
  width: 20px;
`

const ArrowStyled = styled.div`
  width: 12px;
  height: 12px;
  position: absolute;

  &::before {
    content: '';
    background: ${({ theme }) => theme.palette.grey1};
    width: 12px;
    height: 12px;
    border: 2px solid ${({ theme }) => theme.palette.grey1};
    border-radius: 0px 0px 0px 4px;
    transform: rotate(-45deg);
    position: absolute;
  }

  &::after {
    content: '';
    background: white;
    width: 16px;
    height: 16px;
    transform: rotate(-45deg);
    position: absolute;
    border-radius: 0px 0px 0px 3px;
  }

  &[data-placement*='top'] {
    bottom: -5px;
    left: 0;

    &::before {
      top: 0;
      left: 0;
    }

    &::after {
      top: -2px;
      left: 0px;
    }
  }

  &[data-placement*='bottom'] {
    top: -9px;
    left: 0;

    &::before {
      border-radius: 0px 4px 0px 0px;
    }

    &::after {
      border-radius: 0px 3px 0px 0px;
      top: 2px;
    }
  }
`

export default Tooltip
